module.exports = __webpack_public_path__ + "static/media/multipleobjects.82670744.svg";